import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser, selectWithcookieData } from '../../../redux/WithcookieSlice';
import { useTranslation } from '../../../redux/TranslationHelper';

const Header = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // 컴포넌트 마운트 시 스타일 추가
  useEffect(() => {
    const style = document.createElement('style');
    // ID를 추가해서 Bootstrap보다 나중에 로드되도록 함
    style.id = 'hamburger-menu-override';
    style.textContent = `
      /* 최대한 구체적인 선택자 사용 */
      .page-wrapper .site-header__header-one-wrap .main-nav__header-one .header-navigation .main-nav__right .main-nav__left1 a.side-menu__toggler,
      .main-nav__right .main-nav__left1 a.side-menu__toggler,
      .main-nav__left1 a.side-menu__toggler,
      a.side-menu__toggler {
        color: #000000 !important;
      }
      
      .page-wrapper .site-header__header-one-wrap .main-nav__header-one .header-navigation .main-nav__right .main-nav__left1 a.side-menu__toggler i,
      .main-nav__right .main-nav__left1 a.side-menu__toggler i,
      .main-nav__left1 a.side-menu__toggler i,
      a.side-menu__toggler i {
        color: #000000 !important;
      }
      
      /* 모든 상태에서 검은색 유지 */
      a.side-menu__toggler:link,
      a.side-menu__toggler:visited,
      a.side-menu__toggler:hover,
      a.side-menu__toggler:active,
      a.side-menu__toggler:focus {
        color: #000000 !important;
      }
      
      a.side-menu__toggler:link i,
      a.side-menu__toggler:visited i,
      a.side-menu__toggler:hover i,
      a.side-menu__toggler:active i,
      a.side-menu__toggler:focus i {
        color: #000000 !important;
      }
      
      /* 모바일에서 로고 크기 증가 */
      @media (max-width: 768px) {
        .main-nav__left {
          max-width: 180px !important;
          width: 180px !important;
          margin-right: 20px !important;
          padding: 10px 0 !important;
        }
        
        .main-nav__logo .main-logo {
          max-height: 75px !important;
          height: 75px !important;
          max-width: 150px !important;
          width: auto !important;
        }
      }
      
      @media (max-width: 480px) {
        .main-nav__left {
          max-width: 180px !important;
          width: 180px !important;
        }
        
        .main-nav__logo .main-logo {
          max-height: 75px !important;
          height: 75px !important;
          max-width: 150px !important;
          width: auto !important;
        }
      }
    `;
    
    // 스타일을 가장 마지막에 추가
    setTimeout(() => {
      document.head.appendChild(style);
    }, 0);
    
    return () => {
      const existingStyle = document.getElementById('hamburger-menu-override');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, []);
  
  // props로 전달된 데이터 사용
  const propsWithcookieData = props.withcookieData;
  
  // Redux에서 가져온 데이터 (항상 호출)
  const reduxWithcookieData = useSelector(selectWithcookieData);
  
  // 두 데이터 중 선택 (props 우선)
  const withcookieData = propsWithcookieData || reduxWithcookieData;
  
  // props로 전달된 메뉴 데이터 확인 (프리뷰 모드에서 사용)
  const propsMainMenus = props.mainMenus || [];
  const propsGlobalMenus = props.globalMenus || [];
  
  // Redux에서 메뉴 데이터와 로그인 상태 가져오기
  const globalMenus = useSelector(state => state.withcookie?.globalMenus);
  const mainMenus = useSelector(state => state.withcookie?.mainMenus);
  const isUserLoggedIn = useSelector(state => state.withcookie?.isUserLoggedIn);
  
  // 에디터 상태에서 직접 메뉴 데이터 가져오기 (중요: 이 방법을 사용하면 더 확실하게 메뉴를 얻을 수 있음)
  const editorMenus = useSelector(state => state.editor?.menus);
  
 
  
  // 사용할 메뉴 데이터 결정 - 우선순위: props > editorMenus > Redux 메뉴
  let menusToUse = [];
  
  // 1. props로 전달된 메뉴 데이터가 있으면 우선 사용 (프리뷰 모드)
  if (Array.isArray(propsMainMenus) && propsMainMenus.length > 0) {
   
    menusToUse = [...propsMainMenus];
    
    // 글로벌 메뉴가 있으면 추가
    if (Array.isArray(propsGlobalMenus) && propsGlobalMenus.length > 0) {
      menusToUse = [...menusToUse, ...propsGlobalMenus];
    }
  }
  // 2. 에디터 메뉴 데이터가 있는 경우 다음 우선 사용
  else if (Array.isArray(editorMenus) && editorMenus.length > 0) {
   
    menusToUse = [...editorMenus];
  }
  // 3. 그 다음으로 Redux의 withcookie 메뉴 데이터 사용
  else if (Array.isArray(mainMenus) && mainMenus.length > 0) {
   
    menusToUse = [...mainMenus];
    
    // 글로벌 메뉴가 있으면 추가
    if (Array.isArray(globalMenus)) {
      menusToUse = [...menusToUse, ...globalMenus];
    }
  }
  
  
  // 메뉴 액션 처리 함수
  const handleMenuClick = (e, menu) => {
    e.preventDefault();
    
    // 메뉴 액션 처리
    if (menu.menuAction === 'logout') {
      dispatch(logoutUser()).then(() => {
        // 로그아웃 성공 후 홈 페이지로 이동
        navigate('/');
      });
      return;
    }
    
    // 외부 링크 처리
    if (menu.externalLink) {
      window.open(menu.externalLink, '_blank');
      return;
    }
    
    // 일반 내부 링크 처리
    navigate(process.env.PUBLIC_URL + menu.path);
  };
  
  // 메뉴 렌더링 함수
  const renderMenuItems = () => {
    // 메뉴 데이터가 없으면 기본 메뉴 반환
    if (!Array.isArray(menusToUse) || menusToUse.length === 0) {
     
      return (
        <>
          <li className="dropdown current">
            <Link to="/greeting">협회 소개</Link>
            <ul>
              <li><Link to="/greeting">인사말</Link></li>
              <li><Link to="/license">설립허가 및 고유번호증</Link></li>
              <li><Link to="/organization-chart">조직도</Link></li>
              <li><Link to="/vision">협회비전</Link></li>
              <li><Link to="/ci">협회 CI</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/environmental-program">협회 사업</Link>
            <ul>
              <li><Link to="/environmental-education">환경 교육 프로그램</Link></li>
              <li><Link to="/environmental-program">환경 체험 프로그램</Link></li>
              <li><Link to="/nature-restoration-project">풀빛 세상 만들기</Link></li>
              <li><Link to="/csr-consulting">기업 사회 공헌 컨설팅</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/notice">커뮤니티</Link>
            <ul>
              <li><Link to="/notice">공지사항</Link></li>
              <li><Link to="/free-board">자유게시판</Link></li>
              <li><Link to="/gallery">사진갤러리</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/data-room">자료실</Link>
            <ul>
              <li><Link to="/data-room">협회 자료</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/donation">후원 안내</Link>
            <ul>
              <li><Link to="/donation">후원신청</Link></li>
            </ul>
          </li>
          <li className="dropdown" id="loginMenu">
            <Link to="/login">로그인</Link>
            <ul>
              <li><Link to="/sign-up">회원 가입</Link></li>
            </ul>
          </li>
        </>
      );
    }
    
   
    
    // 메뉴 항목 정렬 (order 기준)
    const sortedMenus = [...menusToUse].sort((a, b) => a.order - b.order);
    
    // parentId가 null인 메인 메뉴 항목만 필터링 (글로벌 메뉴 제외)
    const mainMenuItems = sortedMenus.filter(
      menu => menu.parentId === null && 
      menu.visible && 
      menu.type !== 'GLOBAL' && // 글로벌 메뉴는 표시하지 않음
      (
        (!menu.is_logged && !menu.is_not_logged) || // 로그인 관련 속성이 없는 경우 모두 표시
        (menu.is_logged && isUserLoggedIn) ||       // 로그인 필요 메뉴는 로그인 시만 표시
        (menu.is_not_logged && !isUserLoggedIn)     // 비로그인 메뉴는 로그아웃 시만 표시
      )
    );
    
   
    
    // 메인 메뉴 항목이 없으면 기본 메뉴 반환
    if (mainMenuItems.length === 0) {
     
      return (
        <>
          <li className="dropdown current">
            <Link to="/greeting">협회 소개</Link>
            <ul>
              <li><Link to="/greeting">인사말</Link></li>
              <li><Link to="/license">설립허가 및 고유번호증</Link></li>
              <li><Link to="/organization-chart">조직도</Link></li>
              <li><Link to="/vision">협회비전</Link></li>
              <li><Link to="/ci">협회 CI</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/environmental-program">협회 사업</Link>
            <ul>
              <li><Link to="/environmental-education">환경 교육 프로그램</Link></li>
              <li><Link to="/environmental-program">환경 체험 프로그램</Link></li>
              <li><Link to="/nature-restoration-project">풀빛 세상 만들기</Link></li>
              <li><Link to="/csr-consulting">기업 사회 공헌 컨설팅</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/notice">커뮤니티</Link>
            <ul>
              <li><Link to="/notice">공지사항</Link></li>
              <li><Link to="/free-board">자유게시판</Link></li>
              <li><Link to="/gallery">사진갤러리</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/data-room">자료실</Link>
            <ul>
              <li><Link to="/data-room">협회 자료</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/donation">후원 안내</Link>
            <ul>
              <li><Link to="/donation">후원신청</Link></li>
            </ul>
          </li>
          <li className="dropdown" id="loginMenu">
            <Link to="/login">로그인</Link>
            <ul>
              <li><Link to="/sign-up">회원 가입</Link></li>
            </ul>
          </li>
        </>
      );
    }
    
    return mainMenuItems.map(menu => {
      // 현재 메뉴의 하위 메뉴 항목 찾기
      const subMenus = sortedMenus.filter(
        item => item.parentId === menu.id && 
        item.visible && 
        item.type !== 'GLOBAL' &&
        (
          (!item.is_logged && !item.is_not_logged) || // 로그인 관련 속성이 없는 경우 모두 표시
          (item.is_logged && isUserLoggedIn) ||        // 로그인 필요 메뉴는 로그인 시만 표시
          (item.is_not_logged && !isUserLoggedIn)      // 비로그인 메뉴는 로그아웃 시만 표시
        )
      );
      const hasSubMenu = subMenus.length > 0;
      
      return (
        <li key={menu.id} className={`dropdown ${menu.path === window.location.pathname ? 'current' : ''}`}>
          {menu.externalLink || menu.menuAction ? (
            // 외부 링크나 특수 액션이 있는 메뉴
            <a href="#" onClick={(e) => handleMenuClick(e, menu)}>
              {t(menu.name)}
            </a>
          ) : (
            // 일반 내부 링크 메뉴
            <Link to={process.env.PUBLIC_URL + menu.path}>
              {t(menu.name || '메뉴')}
            </Link>
          )}
          
          {hasSubMenu && (
            <ul>
              {subMenus.map(subMenu => (
                <li key={subMenu.id}>
                  {subMenu.externalLink || subMenu.menuAction ? (
                    // 외부 링크나 특수 액션이 있는 서브메뉴
                    <a href="#" onClick={(e) => handleMenuClick(e, subMenu)}>
                      {t(subMenu.name)}
                    </a>
                  ) : (
                    // 일반 내부 링크 서브메뉴
                    <Link to={process.env.PUBLIC_URL + subMenu.path}>
                      {t(subMenu.name || '서브메뉴')}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    });
  };

  return (
    <div className="site-header__header-one-wrap">
      <div className="topbar-one">
        <div className="topbar_bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_kor-environment/images/shapes/header-bg.png)` }}></div>
        <div className="container">
          <div className="topbar-one__left">
            <a href="tel:010-5850-8885"><span className="icon-phone-call"></span>010-5850-8885</a>
            <a href="mailto:gislmh@naver.com"><span className="icon-message"></span>gislmh@naver.com</a>
            <a><span className="icon-clock"></span>9AM - 6PM</a>
          </div>
        </div>
      </div>

      <header className="main-nav__header-one">
        <nav className="header-navigation stricky" style={{ padding: "15px 0" }}>
          <div className="container clearfix">
            <div className="main-nav__left" style={{ maxWidth: "250px", marginRight: "50px", padding: "15px 0" }}>
              <Link to="/" className="main-nav__logo">
                <img 
                  src={withcookieData?.skin?.theme?.main_logo_url || `${process.env.PUBLIC_URL}/assets_kor-environment/images/resources/main-logo2.png`} 
                  className="main-logo" 
                  alt="Awesome Image" 
                  style={{ 
                    height: "auto", 
                    maxHeight: "120px", 
                    width: "auto",
                    maxWidth: "100%",
                    objectFit: "contain",
                    aspectRatio: "auto",
                    padding: "5px 0"
                  }}
                />
              </Link>
            </div>
            <div className="main-nav__main-navigation">
              <ul className="main-nav__navigation-box">
                {renderMenuItems()}
              </ul>
            </div>

            <div className="main-nav__right">
              <div className="main-nav__left1">
                <button
                  className="side-menu__toggler" 
                  style={{ 
                    color: '#000000', 
                    textDecoration: 'none',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '0',
                    fontSize: '20px'
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    // 기존 side-menu__toggler 클릭 이벤트가 자동으로 처리됨
                  }}
                >
                  <i className="fa fa-bars" style={{ color: '#000000' }}></i>
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header; 